<template>
  <div class>
    <!-- 상단 고정 캠페인 배너 -->
    <div v-if="campaignData && campaignData.dynamicLink && campaignData.locationValue === null">
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <div class="pdt-16 pdl-8 pdr-8 pdb-20">
      <div class="graphWrapper pdt-16 pdb-16 pdl-16 pdr-16">
        <div class="header-card ">
            <div class="t-headline2 t-center t-color-headlineBlack t-size70 pdl-16 pdr-16 pdt-50 pdb-30">{{memberTotalPoint.present}}</div>
            <div class="t-body3 t-center t-color-bodyGrayA">{{$t('1894')}}</div>
      </div>
      <div class="d-flex align-items-center justify-content-center mgt-32 mgb-28">
          <a href="javascript:void(0)" class="pdt-7 pdb-8 pdl-11 pdr-11 mgr-8 t-body4 font-r l-spacing12 mdc-button" :class="myStatus=='EARN'?'link-green':'link-inActive'" tabindex="0" @click="moveToEarnLose('EARN')"  @keypress="moveToEarnLose('EARN')">{{$t('1896')}}</a>  <a href="javascript:void(0)" class="l-spacing12 pdt-7 pdb-8 pdl-11 pdr-11 font-r mgl-8 t-body4 mdc-button" :class="myStatus=='LOSE'?'link-red':'link-inActive'" tabindex="0" @click="moveToEarnLose('LOSE')" @keypress="moveToEarnLose('LOSE')">{{$t('1897')}}</a>
      </div>
      <div class="graph border-bottom" v-if="listData.length>0 && graphResult">
              <line-chart :chart-data="graphResult"></line-chart>
            </div>
    </div>
    <div class="mgt-16 mgb-1 d-flex flex-row justify-content-between align-items-baseline  pdl-16 pdr-16">
        <p class="mgb-8 mgt-1 font-b t-color-headlineBlack t-subtitle2">{{$t('1898')}}</p> 
    </div>
      
        <div v-for="(pointList, index) in listData" :key="index" class="pdl-8 pdr-8">
          <!-- 목록 캠페인 카드 -->
          <ListItem :pointList="pointList" :myStatus="myStatus"></ListItem>
        </div>
      
      <infinite-loading  @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
        <div slot="no-more" class="mgt-16">No more data</div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import pointApi from "@/api/pointApi.js";
import memberApi from "@/api/memberApi.js";
import campaignApi from "@/api/campaignApi.js";
import ListItem from "./ListItem.vue";
import NoData from "../common/NoData.vue";
import InfiniteLoading from "vue-infinite-loading";
import LineChart from "./charts/LineChart";

export default {
  components: {
    ListItem,
    NoData,
    InfiniteLoading,
    LineChart
  },

  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
      myStatus: "",
      infiniteId: +new Date(),
      graphResult: null,
      memberTotalPoint: 0,
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
      this.myStatus = this.$route.query.type;
    },
  },

  mounted() {
    // 기본 파라미터 설정(set default parameter)
    this.myStatus = this.$route.query.type;
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let memberTotalPoint = null
        memberApi
          .memberPoint()
          .then((response) => {
            this.memberTotalPoint = response.data.data;
        }).catch((err) => {});

      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        pointApi
          .pointListType(params)
          .then((response) => {
            responseData = response.data.data;
            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
            this.drawGraph(responseData);
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        type: this.$route.query.type,
        // name: "",
        // category: "",
        // page: this.currentPage,
        //sort: 'id,desc',
      };
      return params;
    },

    drawGraph(res) {
      let response = res.content,
        earnPoint = [],
        losePoint = [],
        lables = [];
        let result = response.reduce((acc, curr) => {
          let item = acc.find(item => this.$moment(item.assignTime).format("M/D") === this.$moment(curr.assignTime).format("M/D") );

          if (item) {
            item.point += curr.point;
          } else {
            acc.push(curr);
          }

          return acc;
        }, []);
      for (let res of result) {
        lables.push(this.$moment(res.assignTime).format("M/D"));
        if (res.type.value == "EARN") earnPoint.push(res.point);
        if (res.type.value == "LOSE") losePoint.push(res.point);
      }
      let finalResult = {
        labels: lables,
        datasets: [
          {
            label: '',
            //backgroundColor: '#e0b63a',
            //backgroundColor: "rgba(255, 206, 86, 0.2)",
            //borderColor: "rgba(255, 206, 86, 1)",
            lineTension: 0.1,
            backgroundColor: 'rgba(112, 207, 200, 0.1)',
            borderWidth: 3,
            borderColor: '#70cfc8',
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            fill: false,
            //borderWidth: 2,
            data: earnPoint
          },
          {
            label: '',
            // backgroundColor: '#afd8f8',
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "rgba(255, 99, 132, 1)",
            fill: false,
            borderWidth: 2,
            data: losePoint?losePoint:0
          }
        ]
      };

      this.graphResult = finalResult;
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
    moveToEarnLose(type){
      this.$router.push('/pointearn?type='+type)
    }
  },
};
</script>

<style scoped>
.rewardTitle{
    font-size:16px;
  }
  .crown226{
    max-width: 226px;
  }
  .shadow135{
    max-width: 135px;
    height: 30px;
  }
  .t-size70{
      font-size:70px;
      font-weight: 600;
      line-height: 0.29;
  }
.link-green{
    border-radius: 18px;
    border: solid 1px var(--LectureAqua);
    background-color: var(--LectureAquaBG16);
}
.link-red{
    border-radius: 18px;
  border: solid 1px var(--LectureRed);
  background-color: var(--LectureRedBG6);
}
.border-bottom{
   border-bottom:1px solid var(--Divider);   
  }
  .graphWrapper{
    box-shadow: 0 1px 3px 0 var(--Shadow2);
  }
  .l-spacing12{
    letter-spacing: -0.12px !important;
  }
  .link-inActive {
    border-radius: 18px;
    border: solid 1px var(--Divider);
    background-color: var(--DocumentWhite);
}
</style>